import AgentblazerRenewalModal from "thtoday/agentblazerRenewalModal";

export { AgentblazerRenewalModal };

customElements.define(
  "thtoday-agentblazer-renewal-modal",
  AgentblazerRenewalModal.CustomElementConstructor
);
